import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row, Modal, DatePicker } from "antd";
import axios from "axios";
import "./Pages.css";
import CarteiraClientesPrintModal from "../relatorios/CarteiraClientesPrintModal";
import FiltrosForm from '../components/FiltrosForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario } from "../utils/LoginManager";
import MapaVendasForm from "../components/MapaVendasForm";

const dateFormat = 'DD/MM/YYYY'
const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    qtdeVendas: 0,
    vendasTotais: 0,
    totalRecebido: 0,
    totalReceber: 0,
    totalRecVenc: 0,

    formFiltroVisivel: false,
    filtros: {
      tipoTela: 'CC',
      buscaOrdem: { campo: 'pes_nome', ordem: 'ASC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaMes: 0,
      buscaAno: 0,
      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaMunicipio: { key: '0', },
      buscaAgruparCidades: 0,
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    },
      // this.getListaRegistros
    );
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }


  getListaRegistros = () => {
    this.setState({
      listaRegistros: [], carregando: true,
      qtdeVendas: 0, vendasTotais: 0, totalRecebido: 0, totalReceber: 0, totalRecVenc: 0
    });
    const { pagina, limite } = this.state;

    const { buscaOrdem, buscaDataIni, buscaDataFim, buscaPessoa, buscaUsuario,
      buscaMunicipio, buscaAgruparCidades } = this.state.filtros;

    if ((buscaDataIni) && (buscaDataFim)) {

      let dataIni = '';
      if ((buscaDataIni) && (buscaDataIni !== undefined)) {
        dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      let dataFim = '';
      if ((buscaDataFim) && (buscaDataFim !== undefined)) {
        dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      axios
        .get('/vendas/listaCarteiraCliente', {
          params: {
            page: pagina,
            limite: limite,
            campoOrdem: buscaOrdem.campo,
            tipoOrdem: buscaOrdem.ordem,
            pessoa: buscaPessoa.key,
            cidade: buscaMunicipio.key,
            vendedor: buscaUsuario.key,
            agruparCidades: buscaAgruparCidades,
            dataIni,
            dataFim,
          }
        })
        .then(response => {
          const { data, total, current_page, per_page } = response.data.dados;
          this.setState({
            listaRegistros: data,
            carregando: false,
            total: total,
            pagina: current_page,
            limite: Number(per_page),

            qtdeVendas: response.data.qtdeVendas ? response.data.qtdeVendas : 0,
            vendasTotais: response.data.vendasTotais ? response.data.vendasTotais : 0,
          });

        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });
    } else {
      this.setState({
        listaRegistros: [],
        carregando: false,
      });
    }
  };



  renderData = (data, registro) => {
    let dataMoment = '';
    if ((registro.ultVenda) && (registro.ultOS)) {
      if (moment(registro.ultVenda) > moment(registro.ultOS)) {
        dataMoment = moment(registro.ultVenda);
      } else {
        dataMoment = moment(registro.ultOS);
      }
    } else if (registro.ultVenda) {
      dataMoment = moment(registro.ultVenda);
    } else if (registro.ultOS) {
      dataMoment = moment(registro.ultOS);
    }
    return (
      <span>
        {dataMoment ? dataMoment.format('DD/MM/YYYY') : ''}
      </span>
    )
  }


  renderValor = (vlr) => {
    return (
      <span> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderPercVendas = (vlr) => {
    return (
      <span> {numeral(vlr).format('0,000.0000')} </span>
    );
  };





  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaAgruparCidades: this.state.filtros.buscaAgruparCidades,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formFiltroVisivel, filtros, total, pagina, limite, } = this.state;

    // console.log('CarteiraClientesPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Mapa das Vendas e Clientes</h2>
        <hr />
        <br />

        <Row>
          <div className="pageFiltro" style={{ height: 20 }}>
            <Col xs={24} >

              <Row xs={24} style={{}}>
                <Col xs={2} style={{ width: 110, marginTop: -7 }}>
                  <Button
                    onClick={this.onAbrirFiltroClick}
                    className="pageFiltro-filtrar"
                    style={{ marginRight: 15 }}
                  >
                    Filtrar
                  </Button>
                </Col>

                <FiltrosForm
                  visivel={formFiltroVisivel}
                  onFiltrarClick={this.onFiltrarClick}
                  onCancelarFiltroClick={this.onCancelarFiltroClick}
                  filtros={filtros}
                />

                {/* <Col xs={2} style={{ width: 110, marginTop: -7 }}>
                  <CarteiraClientesPrintModal
                    filtros={filtros}
                    qtdeVendas={this.state.qtdeVendas}
                    vendasTotais={this.state.vendasTotais}
                    periodo={this.state.filtros.buscaDataIni + ' a ' + this.state.filtros.buscaDataFim}
                  />
                </Col> */}

                {/* <Col xs={24} sm={8} style={{ background: "#ececec", padding: 5, marginTop: -15 }}>
                  <Col xs={24} sm={12} style={{ paddingRight: 5, textAlign: "center", background: "white" }} >
                    <Row><span style={{ fontWeight: "bold" }}>Qtde Vendas</span></Row>
                    <Row><span>{this.state.qtdeVendas}</span></Row>
                  </Col>
                  <Col xs={24} sm={12} style={{ paddingRight: 5, textAlign: "center", background: "white" }} >
                    <Row><span style={{ fontWeight: "bold" }}>Vendas Totais</span></Row>
                    <Row><span>R$ {this.renderValor(this.state.vendasTotais)}</span></Row>
                  </Col>
                </Col> */}
              </Row>

            </Col>

          </div>
        </Row>

        <Row>
          <Col xs={8} style={{ paddingRight: 5 }}>
            <Col xs={24} style={{ background: "#ececec", padding: 2 }}>
              <Col xs={24} style={{ background: "white", height: '60vh', }} >
                <span style={{ fontWeight: "bold" }}>Resumo</span>
              </Col>
            </Col>
          </Col>
          <Col xs={16} style={{ height: '60vh' }}>
            <MapaVendasForm />
          </Col>
        </Row>

        {/* GEOCODIFICAÇÃO */}
        {/* https://maps.googleapis.com/maps/api/geocode/json?address=Rua+Vereador+Geremias+Ciliao+Araujo+%2089,+Jd+Albuquerque,+Campo+Mourao,+CA&key=AIzaSyDgE68pxurJkFh52zzpYHxvKjYghvA0Vj0 */}


        {/* GEOCODIFICAÇÃO REVERSA */}
        {/* https://maps.googleapis.com/maps/api/geocode/json?latlng=-24.034061,-52.363037&key=AIzaSyDgE68pxurJkFh52zzpYHxvKjYghvA0Vj0 */}

      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/MapaVendasPage.js